var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "premium-overlay" }, [
    _c("div", { staticClass: "premium-modal" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-warning",
          on: {
            click: function($event) {
              _vm.$router.push("/setting/plan-info")
            }
          }
        },
        [
          _vm._v("\n      ご登録はこちら\n      "),
          _c("i", {
            staticClass: "fa fa-arrow-circle-right fa-lg",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "font-bold" }, [
      _vm._v("\n      商品情報を表示するには "),
      _c("span", { staticClass: "plan-premium-text" }, [_vm._v("プレミアム")]),
      _vm._v(" へのご登録が必要となります\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ad08fff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad08fff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/components/PremiumModalOverlay.vue
// module id = null
// module chunks = 